import TestInfoClasses from '../../components/Tests/TestInfo.module.css';

const PatDocs = ({ files, onView, onDelete }) => {
  return (
    <div>
      <h2 className={TestInfoClasses.testTitle}>Existing Documents</h2>

      {files.map((element) => (
        <div
          key={element.ID}
          style={{ display: 'flex', alignItems: 'center', gap: '12px' }}
        >
          <div style={{ width: '30%' }}>{element.ClientFilename}</div>

          <button
            className={TestInfoClasses['buttonDarkBlue']}
            type="button"
            onClick={() => onView(element)}
          >
            View
          </button>

          <button
            className={TestInfoClasses['buttonDarkBlue']}
            type="button"
            onClick={() => onDelete(element.ID, element.ClientFilename)}
          >
            Delete
          </button>
        </div>
      ))}
    </div>
  );
};

export default PatDocs;